<div class="security-window" [ngStyle]="{'height' : hauteurExplorer() != 0 ? hauteurExplorer() +'%' : '400px'}">

           <div id="conteneur-table">
            <table class="table  col-md-12">
              <tbody>
                  <tr class="">
                    <td class="col-md-6 align-items-center ">
                      <div class="td-align">
                        <b>
                         <span class="">{{'ACCESS_PERMISSION.ACCESS_PERMISSION' | translate }}</span>
                        </b>
                      </div>
                    </td>
                    <td class="col-md-6 align-items-center no-border-right">
                      <div class="td-align">
                        <div class="radio-box">
                            <form action="">
                              <label>
                                <input type="radio" [value]="0" [(ngModel)]="workflowEtapeInstance().accessPermission"   name="accessPermission" id="none" (change)="onChange()"> none
                              </label>

                              <label>
                                <input type="radio" [value]="1" [(ngModel)]="workflowEtapeInstance().accessPermission"   name="accessPermission" id="read" (change)="onChange()"> read
                              </label>

                              <label>
                                <input type="radio" [value]="2" [(ngModel)]="workflowEtapeInstance().accessPermission"   name="accessPermission" id="read-write" (change)="onChange()"> read-write
                              </label>
                            </form>
                          </div>
                    </div>
                    </td>
                  </tr>
              </tbody>
            </table>
          </div>
</div>
